export const Morbi = {
    title: "Morbi",
    title1: "(Historical and Industrial)",

    attractions: [
        {
            name: "Morbi Clock Tower",
            description: "The Morbi Clock Tower is one of the most iconic landmarks of the city, built during the colonial era. It stands as a symbol of the city's rich heritage and is a popular tourist attraction. The tower offers stunning views of the surrounding areas.",
            location: "Morbi, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Photography of the clock tower and surroundings",
                "Explore the nearby markets",
                "Enjoy a peaceful walk around the area"
            ],
            mapLink: "https://maps.app.goo.gl/7H5p3qqL5vU5aRR5A",
        },
        {
            name: "Ranjit Vilas Palace",
            description: "Ranjit Vilas Palace, located in Morbi, is a historical palace with intricate architecture. The palace features a blend of Indian and European designs, making it a unique structure in the region. It’s a great spot for history enthusiasts and photographers.",
            location: "Ranjit Vilas Palace, Morbi, Gujarat",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the palace and its interiors",
                "Photography of the architecture",
                "Learn about the history of the palace"
            ],
            mapLink: "https://maps.app.goo.gl/v9Dzhm5fjR7YcZD47",
        },
        {
            name: "Lakhotiya Dam",
            description: "The Lakhotiya Dam is an important site for nature lovers and those seeking tranquility. The dam is surrounded by lush greenery, making it a great place for a picnic or a peaceful retreat.",
            location: "Lakhotiya, Morbi, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Enjoy a peaceful boat ride",
                "Photography of the scenic views",
                "Relax by the dam"
            ],
            mapLink: "https://maps.app.goo.gl/uwj9sEuh5z58JrEm9",
        },
        {
            name: "Shri Ramakrishna Ashram",
            description: "The Shri Ramakrishna Ashram is a spiritual center that attracts people seeking peace and tranquility. The ashram is known for its calm ambiance and is a perfect place for meditation and introspection.",
            location: "Shri Ramakrishna Ashram, Morbi, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend meditation sessions",
                "Explore the ashram’s peaceful surroundings",
                "Engage in spiritual activities"
            ],
            mapLink: "https://maps.app.goo.gl/fQ34RVr9PLZ9Z2Fz6",
        },
        {
            name: "Morbi Bridge",
            description: "The Morbi Bridge, also known as the ‘Madhavji Bridge,’ is an engineering marvel and one of the oldest suspension bridges in India. The bridge offers a scenic view of the Machchhu River and the surrounding area.",
            location: "Morbi, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Walk across the bridge",
                "Photography of the river and bridge",
                "Enjoy the sunset or sunrise views"
            ],
            mapLink: "https://maps.app.goo.gl/SgdfTRMNwBgyZJgY9",
        },
        {
            name: "Khodaldham Temple",
            description: "Khodaldham Temple, located near Morbi, is dedicated to Goddess Khodaldham. It is a revered pilgrimage site that attracts thousands of devotees annually. The temple is known for its beautiful architecture and serene surroundings.",
            location: "Khodaldham Temple, Near Morbi, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Attend religious ceremonies",
                "Explore the temple premises",
                "Participate in local festivals like Khodaldham Fair"
            ],
            mapLink: "https://maps.app.goo.gl/QtiQzFQWsnzdbnxL7",
        },
        {
            name: "Vishwamitri River",
            description: "The Vishwamitri River runs through the city of Morbi and is an important water body in the region. The riverbanks offer a peaceful environment for evening walks and photography.",
            location: "Vishwamitri River, Morbi, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Photography of the river",
                "Relax along the riverbanks",
                "Enjoy an evening walk"
            ],
            mapLink: "https://maps.app.goo.gl/DQXH6qZ7EoPC9iP6A",
        },
        {
            name: "Madhavji Temple",
            description: "Madhavji Temple is one of the oldest temples in Morbi, dedicated to Lord Krishna. The temple is a beautiful example of Hindu temple architecture and attracts many pilgrims each year.",
            location: "Madhavji Temple, Morbi, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Visit the temple for prayers",
                "Explore the architecture",
                "Photography of the temple"
            ],
            mapLink: "https://maps.app.goo.gl/Ak8H2yE9YxtpF5t98",
        },
        {
            name: "Morbi Art Gallery",
            description: "Morbi Art Gallery is a cultural hub that showcases various forms of art, including paintings, sculptures, and handicrafts. It’s a great place for art lovers and those interested in the cultural heritage of Gujarat.",
            location: "Morbi Art Gallery, Morbi, Gujarat",
            timings: "10:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the artwork",
                "Attend art exhibitions",
                "Photography of the artwork"
            ],
            mapLink: "https://maps.app.goo.gl/5uA2rytnnF79Hkks8",
        },
        {
            name: "Watson Museum",
            description: "The Watson Museum, located in Rajkot, is a museum of historical and cultural significance. Though not directly in Morbi, it’s a must-visit nearby attraction that showcases the rich heritage of the Saurashtra region.",
            location: "Watson Museum, Rajkot, Gujarat",
            timings: "10:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Throughout the Year",
            activities: [
                "Explore the museum's artifacts",
                "Learn about the history of Saurashtra",
                "Photography of the museum exhibits"
            ],
            mapLink: "https://maps.app.goo.gl/x6rWmShzgphgYyHM8",
        },
        {
            name: "Nehrunagar",
            description: "Nehrunagar is a beautiful park in Morbi, known for its lush green lawns and tranquility. It's a perfect spot for a family outing or a peaceful walk.",
            location: "Nehrunagar, Morbi, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Take a stroll in the park",
                "Photography of the garden",
                "Relax and unwind"
            ],
            mapLink: "https://maps.app.goo.gl/84VhLxU3V3TpyAYdA",
        },
        {
            name: "Gujarat Ceramic Industry",
            description: "Morbi is known for its ceramic industry, which is one of the largest in India. Visiting the ceramic factories provides insight into the region's industrial prowess and craftsmanship.",
            location: "Gujarat Ceramic Industry, Morbi, Gujarat",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Weekdays",
            activities: [
                "Tour the ceramic factories",
                "Learn about ceramic production",
                "Purchase ceramic products"
            ],
            mapLink: "https://maps.app.goo.gl/V6W7k37nyyzk1B9u8",
        }
    ]
};
